module.exports = __webpack_public_path__ + "static/media/place_marker.b7e3884a.png";